import ErrorFallback from '@/components/Base/ErrorFallback';
import ScrollToTop from '@/components/Base/ScrollToTop';
import ErrorBoundary from '@/components/ErrorBoundary';
import { StrictMode } from 'react';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import './assets/css/app.css';
import Router from './router';
import { store } from './stores/store';
import { ClientAwareRouter } from './utils/ClientRouter';
import { injectStore } from './utils/helper';
import { PdfGenerationProvider } from './components/Pulse/PdfGenerationContext';

// Force-logout all users once (clears stale sessions on first visit after deploy).
// After clearing, the flag is re-set so subsequent visits are unaffected.
if (!localStorage.getItem('force_logout_v2')) {
  localStorage.clear();
  localStorage.setItem('force_logout_v2', 'true');
}

// Dev-only: stamp localStorage + Redux with a fake admin if no auth
// token exists (Beacon prototype runs without the Antares Backend, so
// the real login flow can't complete).
//
// Loaded via dynamic import gated on `import.meta.env.DEV` so that
// Vite's static replacement + tree-shaking eliminates this entire
// branch — and the `devAuthSeed.dev` module it references — from
// production bundles. The seed embeds seeded superowner credentials
// in source, so it must never reach prod. The `.dev.ts` filename
// suffix is the human-readable counterpart of the same contract.
if (import.meta.env.DEV) {
  import('./utils/devAuthSeed.dev').then(({ seedDevAuthIfNeeded }) => {
    seedDevAuthIfNeeded();
  });
}

injectStore(store);

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <ErrorBoundary fallback={<ErrorFallback />}>
    <ClientAwareRouter>
      <StrictMode>
        <Provider store={store}>
          <PdfGenerationProvider>
            <Router />
          </PdfGenerationProvider>
        </Provider>
      </StrictMode>
      <ScrollToTop />
    </ClientAwareRouter>
  </ErrorBoundary>
);
